module.exports = __webpack_public_path__ + "static/media/lighthouse.d5ed75e3.jpg";